/* GrubTerra native cart drawer. Config comes from sections/gt-cart.liquid (#GTCartConfig). */
(() => {
  if (customElements.get('cart-drawer')) return;
  const cfgEl = document.getElementById('GTCartConfig');
  if (!cfgEl) return;
  const cfg = JSON.parse(cfgEl.textContent);
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const nativeFetch = window.fetch.bind(window);
  const CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  const esc = (v) => String(v == null ? '' : v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  // Hen Harmony variant names read "1-8 / 1 Pack" in Shopify; show shoppers "For 1–8 hens · 1 pack".
  const vName = (t) => { const m = /^(\d+)-(\d+\+?)\s*\/\s*(\d+)\s*Pack$/i.exec(String(t || '').trim()); return m ? 'For ' + m[1] + '–' + m[2] + ' hens · ' + m[3] + (m[3] === '1' ? ' pack' : ' packs') : String(t == null ? '' : t); };
  const money = (cents) => {
    const n = (Number(cents) || 0) / 100;
    const withDec = n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const noDec = Math.round(n).toLocaleString('en-US');
    return (cfg.moneyFormat || '${{amount}}')
      .replace(/<[^>]*>/g, '')
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace(/,/g, ' ').replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withDec);
  };
  const fill = (tpl, map) => String(tpl || '').replace(/\{(\w+)\}/g, (m, k) => (k in map ? map[k] : m));
  const shortTitle = (t) => (cfg.upsellShortTitles ? String(t).split(/\.\s/)[0].replace(/\.$/, '') : t);
  const img = (url, w) => (url ? url + (url.includes('?') ? '&' : '?') + 'width=' + w : '');
  const isGift = (item) => item.properties && item.properties._gt_gift;
  // Free bonuses (ebooks, shipping protection) are auto-added lines shown compactly under the products.
  const bonusIds = new Set(((cfg.bonus && cfg.bonus.items) || []).map((b) => b.productId));
  const isAddon = (item) => bonusIds.has(item.product_id);
  const isProduct = (item) => !isGift(item) && !isAddon(item);
  // Coop Refresher deal page (/products/grubterra-coop-refresher?view=coop-bulk). sub = paid subscription bags, subFree = the $0 FREE bags
  // on the same plan, paid/free = one-time Buy X Get Y bags. Every Coop branch below only runs for these products.
  const COOP = cfg.coop && (cfg.coop.sub || cfg.coop.paid) ? cfg.coop : null;
  const isCoopSub = (it) => !!COOP && !!COOP.sub && it.product_id === COOP.sub;
  const isCoopPaid = (it) => !!COOP && !!COOP.paid && it.product_id === COOP.paid;
  const isCoopFree = (it) => !!COOP && !!COOP.free && it.product_id === COOP.free;
  const isCoopSubFree = (it) => !!COOP && !!COOP.subFree && it.product_id === COOP.subFree;
  const isCoop = (it) => isCoopSub(it) || isCoopPaid(it) || isCoopFree(it) || isCoopSubFree(it);
  // Coop deal page auto-refill (Oct 19): one line per scent on coop-refresher-auto-refill, all on the tier's plan. Shown as ONE deal
  // (paid bags + a FREE bags row + the refill terms), same as the Peck Purity bulk box; the bag total is locked to the tier.
  const COOPR = cfg.coopRefill && cfg.coopRefill.sub ? cfg.coopRefill : null;
  const isCoopRefill = (it) => !!COOPR && it.product_id === COOPR.sub;
  const coopRTier = (it) => (COOPR && it.selling_plan_allocation && COOPR.plans[String(it.selling_plan_allocation.selling_plan.id)]) || null;
  // Peck Purity bulk deal subscription (?view=bogo, Auto-refill): ONE line of 4/7/12 bags on a 3/5/8-month plan. The first box is
  // the deal price (plan's first-order %), refills are the same bags at 10% off. The cart shows it as paid bags + a FREE bags row.
  const PPB = cfg.ppBulk && cfg.ppBulk.sub ? cfg.ppBulk : null;
  const HHB = cfg.hhBulk && cfg.hhBulk.sub ? cfg.hhBulk : null;
  const BULKS = [PPB, HHB].filter(Boolean);
  // Buy 2 Get 1 box (3-Month Supply ×3, sold on the Ryze-style ?view=offer page as Buy 2 Get 1 / Buy 4 Get 2 / Buy 6 Get 3):
  // no flock switcher, fixed qty, line reads "Buy X Get Y FREE · N pouches"; its remove also takes the e-book pack it brought.
  // Hen Harmony 3-Month Supply (Ryze-style ?view=hh-offer, ryze-hh/HANDOFF.md): the same box in bags. b2* helpers pick its name, photo, base price and unit word.
  const isHHB2 = (it) => it.handle === 'hen-harmony-3-month-supply';
  const isB2Box = (it) => it.handle === 'peck-purity-3-month-supply' || isHHB2(it);
  const b2Pouches = (it) => { const m = /(\d+)\s*(?:pouch|bag)/i.exec(it.variant_title || ''); return (m ? Number(m[1]) : 1); };
  const b2Unit = (it, n) => (isHHB2(it) ? (n === 1 ? ' bag' : ' bags') : (n === 1 ? ' pouch' : ' pouches'));
  const b2Name = (it) => (isHHB2(it) ? 'Hen Harmony' : 'Peck Purity');
  // Oct 15 (Michael): Buy 2 Get 1 gift-stack cart, ported from the B2G1 test theme 146316361841. With cfg.b2Offer set, the 3-Month box shows
  // its paid bags, the free 3rd bag as its own row, and every freebie as a row in a "N FREE gifts" box; the Monthly Plan gets the gift box too.
  // base = the $32.99 single-pouch price every saving is measured against (Michael's rule). cfg.b2Offer in gt-cart.liquid can override.
  const HH_COVERS = ['https://cdn.shopify.com/s/files/1/0046/3716/3633/files/lp-ebook-hot-summers.jpg?v=1790605811', 'https://cdn.shopify.com/s/files/1/0046/3716/3633/files/lp-ebook-good-bug.jpg?v=1790605811', 'https://cdn.shopify.com/s/files/1/0046/3716/3633/files/lp-ebook-egg-thief.jpg?v=1790605811'];
  const B2O = (cfg.b2g1 || []).some(Boolean) ? Object.assign({ base: 3299, ship: 699, pouchImg: 'https://cdn.shopify.com/s/files/1/0046/3716/3633/files/peck-purity-12.png?v=1779177683' }, cfg.b2Offer || {}) : null;
  if (B2O && !document.getElementById('gt-b2-gifts-css')) {
    const st = document.createElement('style'); st.id = 'gt-b2-gifts-css';
    st.textContent = `#GTCart .gt-gifts { margin: 14px 0 6px; padding: 12px 12px 6px; border: 2px dashed #1F6223; border-radius: 14px; background: #F1F6F0; } #GTCart .gt-gifts-h { display: flex; align-items: center; justify-content: space-between; gap: 8px; margin: 0 0 8px; font-weight: 900; font-size: 15px; color: #1F6223; text-transform: uppercase; letter-spacing: .02em; } #GTCart .gt-gifts-h span { flex: none; background: #FFCC2F; color: #1a1a1a; border-radius: 999px; padding: 3px 10px; font-size: 12px; letter-spacing: 0; } #GTCart .gt-gift { display: flex; align-items: center; gap: 12px; padding: 10px 0; border-top: 1px solid rgba(31,98,35,.14); } #GTCart .gt-gift:first-of-type { border-top: 0; } #GTCart .gt-gift-m { flex: none; width: 56px; height: 56px; border-radius: 10px; background: #fff; display: flex; align-items: center; justify-content: center; position: relative; overflow: visible; box-shadow: 0 1px 3px rgba(0,0,0,.08); } #GTCart .gt-gift-m > img { max-width: 48px; max-height: 48px; object-fit: contain; } #GTCart .gt-gift-m svg { width: 40px; height: 40px; } #GTCart .gt-gift-covers { display: flex; align-items: center; justify-content: center; } #GTCart .gt-gift-covers img { display: block; flex: none; width: 22px; height: 30px; max-width: none; object-fit: cover; border-radius: 2px; box-shadow: 0 1px 2px rgba(0,0,0,.25); margin: 0 0 0 -8px; } #GTCart .gt-gift-covers img:first-child { margin-left: 0; } #GTCart .gt-gift-x { position: absolute; right: -6px; bottom: -6px; background: #1F6223; color: #fff; font-size: 11px; font-weight: 800; border-radius: 999px; padding: 1px 6px; font-style: normal; } #GTCart .gt-gift-t { flex: 1; min-width: 0; display: flex; flex-direction: column; gap: 2px; } #GTCart .gt-gift-t b { font-size: 15px; font-weight: 800; color: #1a1a1a; line-height: 1.2; } #GTCart .gt-gift-t small { font-size: 12.5px; color: #5b6b5c; line-height: 1.3; } #GTCart .gt-gift-p { flex: none; display: flex; flex-direction: column; align-items: flex-end; gap: 2px; } #GTCart .gt-gift-p s { font-size: 13px; color: #8a8a8a; } #GTCart .gt-gift-p .gt-free { background: #1F6223; color: #fff; border-radius: 6px; padding: 2px 8px; font-size: 13px; font-weight: 900; letter-spacing: .04em; } #GTCart .gt-item--freebag { background: #F1F6F0; border: 2px dashed #1F6223; border-radius: 12px; padding: 10px; } #GTCart .gt-img--bag { position: relative; display: flex; align-items: center; justify-content: center; background: #fff; border-radius: 10px; overflow: visible; } #GTCart .gt-img--bag .gt-gift-x { right: 4px; bottom: 4px; z-index: 2; font-size: 13px; padding: 2px 7px; line-height: 1.2; box-shadow: 0 1px 3px rgba(0,0,0,.25); } #GTCart .gt-img--bag img { object-fit: contain; } #GTCart .gt-item--freebag .gt-name { font-weight: 800; color: #1F6223; } #GTCart .gt-item--freebag .gt-free { background: #1F6223; color: #fff; border-radius: 6px; padding: 2px 8px; font-size: 13px; font-weight: 900; letter-spacing: .04em; } #GTCart .gt-qtyfix { font-size: 13px; font-weight: 700; color: #1F6223; background: #F1F6F0; border-radius: 8px; padding: 6px 10px; }`;
    document.head.appendChild(st);
  }
  const isB2Monthly = (it) => !!B2O && (cfg.b2g1 || [])[1] === it.product_id;
  const b2Base = (it) => (isHHB2(it) && cfg.b2Hh ? cfg.b2Hh.base : B2O.base);
  const b2Img = (it) => (isHHB2(it) && cfg.b2Hh ? cfg.b2Hh.img : B2O.pouchImg);
  // what the 3rd bag costs right now: $0 once the automatic "3rd Bag FREE" discount covers one bag
  const bagCharge = (it) => ((it.line_level_discount_allocations || []).reduce((a, d) => a + d.amount, 0) >= it.original_price ? 0 : it.original_price);
  const SVG_TRUCK = '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="19" fill="#1F6223"/><g transform="translate(8 8)" fill="none" stroke="#FFCC2F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 5h13v11H1z"/><path d="M14 9h4l3 3v4h-7z"/><circle cx="5.5" cy="18" r="1.8"/><circle cx="17.5" cy="18" r="1.8"/></g></svg>';
  const SVG_SHIELD = '<svg viewBox="0 0 40 44" aria-hidden="true"><path d="M20 2l16 6v12c0 10-7 18.5-16 22C11 38.5 4 30 4 20V8l16-6z" fill="#1F6223"/><path d="M13 17l7-4 7 4v9l-7 4-7-4z" fill="none" stroke="#FFCC2F" stroke-width="2" stroke-linejoin="round"/><path d="M13 17l7 4 7-4M20 21v9" fill="none" stroke="#FFCC2F" stroke-width="2" stroke-linejoin="round"/></svg>';
  const bulkOf = (it) => BULKS.find((b) => it.product_id === b.sub) || null;
  const isPPBulk = (it) => !!bulkOf(it);
  const ppbTier = (it) => { const b = bulkOf(it); return (b && it.selling_plan_allocation && b.plans[String(it.selling_plan_allocation.selling_plan.id)]) || null; };
  // "Monthly Subscription" stays as-is; "Every 3 Months" reads "Delivered every 3 months".
  const planLabel = (name) => { const n = String(name).trim(); if (/subscri/i.test(n)) return n; const r = n.replace(/^deliver(y|ed)\s+/i, ''); return 'Delivered ' + r.charAt(0).toLowerCase() + r.slice(1).toLowerCase(); };
  // Best selling plan for a variant: name contains the preferred keyword, else the first one offered.
  const pickPlan = (prod, variant) => {
    const allocs = (variant && variant.selling_plan_allocations) || [];
    if (!allocs.length) return null;
    const plans = (prod.selling_plan_groups || []).flatMap((g) => g.selling_plans);
    const kw = String(cfg.subPlanKeyword || '').toLowerCase();
    const a = allocs.find((x) => { const p = plans.find((y) => y.id === x.selling_plan_id); return p && kw && p.name.toLowerCase().includes(kw); }) || allocs[0];
    const plan = plans.find((y) => y.id === a.selling_plan_id) || { name: '' };
    return { id: a.selling_plan_id, price: a.price, name: plan.name };
  };

  // Full value of one unit = the highest of compare-at, regular price and the plan's compare price,
  // so "% off" is measured against the real value of what's in the cart.
  const unitValue = (variant, sp, fallback) =>
    Math.max((variant && variant.compare_at_price) || 0, (variant && variant.price) || 0, (sp && sp.compare_at_price) || 0, fallback || 0);

  // Cross-sell: the cheapest plan whose name contains the keyword (e.g. "3 Month"), so a new 20%-first plan wins once attached.
  const offerPlan = (prod, variant) => {
    const kw = String(cfg.feature.plan || '').toLowerCase();
    const plans = (prod.selling_plan_groups || []).flatMap((g) => g.selling_plans);
    let best = null;
    ((variant && variant.selling_plan_allocations) || []).forEach((a) => {
      const p = plans.find((y) => y.id === a.selling_plan_id);
      if (p && (!kw || p.name.toLowerCase().includes(kw)) && (!best || a.price < best.price)) best = { id: a.selling_plan_id, price: a.price, name: p.name };
    });
    return best;
  };
  // "Every 3 Months" / "3 Month Subscription" → "every 3 months".
  const cadence = (name) => {
    const m = /(\d+)\s*month/i.exec(name || '');
    if (m) return Number(m[1]) === 1 ? 'every month' : 'every ' + m[1] + ' months';
    return /month/i.test(name || '') ? 'every month' : String(name || '').toLowerCase();
  };
  const words = (v) => String(v || '').split(',').map((x) => x.trim().toLowerCase()).filter(Boolean);
  const offerHas = (o, item) => words(o.match).some((w) => String(item.handle).toLowerCase().includes(w));

  const productCache = {};
  const getProduct = (handle) =>
    (productCache[handle] ||= nativeFetch(root + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null));

  const addBusinessDays = (d, n) => {
    const x = new Date(d);
    while (n > 0) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) n--; }
    return x;
  };
  const fmtDate = (d) => d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });

  const ICON = {
    minus: '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    plus: '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    trash: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M10 11v6M14 11v6M6 7l1 12a2 2 0 002 2h6a2 2 0 002-2l1-12M9 7V4h6v3"/></svg>',
    check: '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
    gift: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13M12 7c-2-4-6-3-5 0M12 7c2-4 6-3 5 0"/></svg>',
    lock: '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2"><rect x="5" y="11" width="14" height="10" rx="2"/><path d="M8 11V8a4 4 0 018 0v3"/></svg>',
    shield: '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 3l8 3v6c0 4.5-3.4 8.2-8 9-4.6-.8-8-4.5-8-9V6z"/><path d="M8.5 12l2.5 2.5 4.5-5" stroke-linecap="round"/></svg>',
    clock: '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg>',
    star: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9z"/></svg>',
    cal: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><rect x="3.5" y="5" width="17" height="15" rx="2"/><path d="M3.5 10h17M8 3v4M16 3v4"/><path d="M12.5 14.5l1.5 1.5 3-3"/></svg>',
    money: '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M12 3v18M16.5 7.5c-.8-1.3-2.5-2-4.5-2-2.5 0-4.2 1.3-4.2 3.2 0 4.4 8.9 2.3 8.9 6.7 0 1.9-1.9 3.2-4.7 3.2-2.1 0-3.9-.8-4.8-2.3"/></svg>',
    tag: '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M3 12V4h8l9 9-8 8z"/><circle cx="7.5" cy="8.5" r="1.4"/></svg>',
    box: '<svg viewBox="0 0 24 24" width="17" height="17" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z"/><path d="M4 7.5l8 4.5 8-4.5M12 12v9"/></svg>',
    book: '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linejoin="round"><path d="M4 5.5A2.5 2.5 0 016.5 3H20v15H6.5A2.5 2.5 0 004 20.5z"/><path d="M4 20.5A2.5 2.5 0 016.5 18H20v3H6.5A2.5 2.5 0 014 20.5z"/></svg>',
    repeat: '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 2l3 3-3 3M4 11V9a4 4 0 014-4h12M7 22l-3-3 3-3M20 13v2a4 4 0 01-4 4H4"/></svg>',
  };

  class GTCart extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.panel = this.querySelector('.gt-panel');
      this.$ = (sel) => this.querySelector(sel);
      this.products = {};
      this.busy = false;

      this.addEventListener('click', (e) => this.onClick(e));
      this.addEventListener('change', (e) => this.onChange(e));
      document.addEventListener('keydown', (e) => {
        if (!this.isOpen) return;
        if (e.key === 'Escape') this.close();
        if (e.key === 'Tab') this.trapTab(e);
      });
      // Header icon, buy box ".click()" on the icon, and any [data-gt-open] element open the drawer.
      document.addEventListener('click', (e) => {
        const t = e.target.closest('#cart-icon-bubble, [data-gt-open]');
        if (!t) return;
        e.preventDefault();
        this.setActiveElement(t);
        this.open();
      }, true);

      this.watchCartRequests();
      this.startTimer();
      this.refresh();
    }

    /* ---------- reservation countdown: restarts at zero, survives page loads in the same tab ---------- */
    startTimer() {
      if (!cfg.timerEnabled) return;
      const len = Math.max(1, Number(cfg.timerMinutes) || 10) * 60000;
      const KEY = 'gtCartTimerEnd';
      const read = () => { try { return Number(sessionStorage.getItem(KEY)) || 0; } catch (e) { return this._timerEnd || 0; } };
      const write = (v) => { this._timerEnd = v; try { sessionStorage.setItem(KEY, String(v)); } catch (e) {} };
      const tick = () => {
        let end = read();
        const now = Date.now();
        if (!end || end <= now || end - now > len) { end = now + len; write(end); }
        const s = Math.ceil((end - now) / 1000);
        this._timerText = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
        const el = this.querySelector('[data-gt-time]');
        if (el) el.textContent = this._timerText;
      };
      tick();
      setInterval(tick, 1000);
    }

    get isOpen() { return this.classList.contains('is-open'); }

    /* ---------- public API the theme already calls ---------- */
    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      this.setAttribute('aria-hidden', 'false');
      void this.offsetWidth; // commit the closed state first so the slide-in transition runs
      this.classList.add('is-open');
      document.documentElement.classList.add('gt-lock');
      setTimeout(() => this.panel.focus({ preventScroll: true }), 50);
      document.dispatchEvent(new CustomEvent('gt-cart:open'));
    }
    close() {
      this.classList.remove('is-open');
      this.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('gt-lock');
      if (this.activeElement && this.activeElement.focus) this.activeElement.focus({ preventScroll: true });
    }
    renderContents() { return this.refresh().then(() => this.open()); }
    getSectionsToRender() { return [{ id: 'cart-icon-bubble' }]; }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
    setActiveElement(el) { this.activeElement = el; }

    trapTab(e) {
      const f = [...this.panel.querySelectorAll('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])')].filter((x) => x.offsetParent);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    /* ---------- cart requests from anywhere else on the page ---------- */
    watchCartRequests() {
      const self = this;
      let timer;
      const after = (isAdd) => {
        const silent = cfg.silentSelectors && document.activeElement && document.activeElement.closest && (() => {
          try { return document.activeElement.closest(cfg.silentSelectors); } catch (err) { return null; }
        })();
        clearTimeout(timer);
        timer = setTimeout(() => {
          self.refresh().then(() => { if (isAdd && cfg.openOnAdd && !silent && !self.isOpen) self.open(); });
        }, 120);
      };
      window.fetch = function (input, init) {
        const url = typeof input === 'string' ? input : (input && input.url) || '';
        const p = nativeFetch(input, init);
        if (CART_RE.test(url)) p.then((r) => { if (r.ok) after(/\/cart\/add/.test(url)); }).catch(() => {});
        return p;
      };
      const oOpen = XMLHttpRequest.prototype.open;
      const oSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (m, u) { this._gtUrl = String(u || ''); return oOpen.apply(this, arguments); };
      XMLHttpRequest.prototype.send = function () {
        if (CART_RE.test(this._gtUrl || '')) {
          const url = this._gtUrl;
          this.addEventListener('load', () => { if (this.status >= 200 && this.status < 300) after(/\/cart\/add/.test(url)); });
        }
        return oSend.apply(this, arguments);
      };
    }

    /* ---------- data ---------- */
    async api(path, body) {
      const r = await nativeFetch(root + path, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      const j = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
      return j;
    }
    fetchCart() {
      return nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then((r) => r.json());
    }
    async refresh(cart) {
      try {
        this.cart = cart || (await this.fetchCart());
        await this.syncCoopFree();
        await this.syncPPBulk();
        await this.syncCoopRefill();
        await this.syncGifts();
        await this.syncProtection();
        const handles = [...new Set(this.cart.items.filter(isProduct).map((i) => i.handle))];
        const prods = await Promise.all(handles.map(getProduct));
        handles.forEach((h, i) => { this.products[h] = prods[i]; });
        this.offer = this.pickOffer();
        this.offerProduct = this.offer ? await getProduct(this.offer.handle) : null;
        this.render();
      } catch (err) {
        console.warn('[gt-cart]', err);
      }
      return this.cart;
    }
    async mutate(fn) {
      if (this.busy) return;
      this.busy = true;
      this.classList.add('is-busy');
      try {
        const cart = await fn();
        await this.refresh(cart && cart.items ? cart : undefined);
      } catch (err) {
        this.toast(err.message);
        await this.refresh();
      } finally {
        this.busy = false;
        this.classList.remove('is-busy');
      }
    }
    changeLine(line, payload) { return this.mutate(() => this.api('cart/change.js', Object.assign({ line }, payload))); }

    baseTotal() {
      return this.cart.items.filter(isProduct).reduce((a, i) => a + i.final_line_price, 0);
    }
    activeTiers() {
      return (cfg.tiers || []).filter((t) => t.enabled && t.amount > 0).sort((a, b) => a.amount - b.amount);
    }
    // Free bonuses ride along with any real product: added once (qty 1), removed when the cart has no products.
    async syncProtection() {
      const b = cfg.bonus;
      if (!b || !b.enabled || !b.items.length || this._syncingP) return;
      const lines = this.cart.items.filter(isAddon);
      const eligible = this.cart.items.some((i) => isProduct(i) && (!b.subsOnly || i.selling_plan_allocation));
      const eligibleFor = (x) => (x && x.triggers && x.triggers.length ? this.cart.items.some((i) => isProduct(i) && x.triggers.includes(i.product_id)) : eligible);
      const itemOf = (line) => b.items.find((x) => x.productId === line.product_id);
      let updates = null, add = [];
      // Never charge for a bonus: drop any bonus line that would cost money, and only add $0 variants.
      const charged = lines.filter((i) => i.final_line_price > 0);
      if (charged.length) this._bonusBlocked = true; // not actually free (no $0 price or discount): stop re-adding this visit
      // Packs with "triggers" (the Coop deal's 2nd e-book pack) are only ever ADDED here; they leave with the Coop deal (remove button).
      // Every other pack is dropped exactly as before.
      const isTriggerPack = (i) => { const x = itemOf(i); return !!(x && x.triggers && x.triggers.length); };
      // Oct 13: a trigger pack also leaves once nothing in the cart earns it (no subscription and none of its trigger products),
      // so removing the last HH / Coop / larvae subscription doesn't leave a lone $0 e-book bundle behind.
      const drop = lines.filter((i) => (!isTriggerPack(i) && (!eligible || i.final_line_price > 0)) || (isTriggerPack(i) && !eligible && !eligibleFor(itemOf(i))));
      const fix = lines.filter((i) => !drop.includes(i) && i.quantity > 1);
      if (drop.length || fix.length) updates = Object.fromEntries([...drop.map((i) => [i.key, 0]), ...fix.map((i) => [i.key, 1])]);
      if (!this._bonusBlocked) add = b.items.filter((x) => eligibleFor(x) && x.variantId && (x.price === 0 || b.discounted) && !lines.some((i) => i.product_id === x.productId)).map((x) => ({ id: x.variantId, quantity: 1 }));
      if (!updates && !add.length) return;
      this._syncingP = true;
      try {
        if (updates) await this.api('cart/update.js', { updates });
        if (add.length) await this.api('cart/add.js', { items: add });
        this.cart = await this.fetchCart();
        // Two cart events close together can each add the same $0 pack (Shopify merges them into quantity 2).
        // Trim any pack back to 1 now instead of waiting for the next cart change.
        const dup = this.cart.items.filter((i) => isAddon(i) && i.quantity > 1);
        if (dup.length) {
          await this.api('cart/update.js', { updates: Object.fromEntries(dup.map((i) => [i.key, 1])) });
          this.cart = await this.fetchCart();
        }
      } catch (err) {
        console.warn('[gt-cart] bonus sync', err);
      } finally {
        this._syncingP = false;
      }
    }

    ppBulkMode() {
      return BULKS.length > 0 && !!this.cart && this.cart.items.some(isPPBulk);
    }
    // Buy 2 Get 1 offer lines (first order ships free): hide the free-shipping progress bar, like the offer theme does.
    offerMode() {
      return !!B2O && this.b2g1Mode();
    }
    b2g1Mode() {
      const ids = cfg.b2g1 || [];
      return !!this.cart && this.cart.items.some((i) => ids.includes(i.product_id));
    }
    // A Peck Purity bulk box is always its tier's bag count (4 / 7 / 12), whatever /cart or the theme tries to set.
    async syncPPBulk() {
      if (!BULKS.length || this._syncingB) return;
      const updates = {};
      this.cart.items.filter(isPPBulk).forEach((i) => { const t = ppbTier(i); if (t && i.quantity !== t.total) updates[i.key] = t.total; });
      if (!Object.keys(updates).length) return;
      this._syncingB = true;
      try {
        await this.api('cart/update.js', { updates });
        this.cart = await this.fetchCart();
      } catch (err) {
        console.warn('[gt-cart] pp bulk sync', err);
      } finally {
        this._syncingB = false;
      }
    }
    coopSubMode() {
      return !!this.cart && this.cart.items.some((i) => isCoopSub(i) || isCoopRefill(i));
    }
    // A Coop auto-refill box is always its tier's bag count (3 / 5 / 9) across its scent lines: trim from, or top up, the biggest line.
    async syncCoopRefill() {
      if (!COOPR || this._syncingR) return;
      const lines = this.cart.items.filter(isCoopRefill);
      if (!lines.length) return;
      const t = coopRTier(lines[0]);
      if (!t || lines.some((l) => coopRTier(l) !== t)) return;
      const q = lines.map((l) => l.quantity);
      let sum = q.reduce((a, b) => a + b, 0);
      if (sum === t.total) return;
      while (sum > t.total) { const j = q.indexOf(Math.max(...q)); q[j]--; sum--; }
      while (sum < t.total) { const j = q.indexOf(Math.max(...q)); q[j]++; sum++; }
      const updates = {};
      lines.forEach((l, k) => { if (q[k] !== l.quantity) updates[l.key] = q[k]; });
      this._syncingR = true;
      try {
        await this.api('cart/update.js', { updates });
        this.cart = await this.fetchCart();
      } catch (err) {
        console.warn('[gt-cart] coop refill sync', err);
      } finally {
        this._syncingR = false;
      }
    }
    // Coop subscription boxes: never more FREE bags than the paid bags earn (2 -> 1, 3 -> 2, 5 -> 4; anything else -> 0).
    async syncCoopFree() {
      if (!COOP || !COOP.subFree || this._syncingC) return;
      const items = this.cart.items;
      const paid = items.filter(isCoopSub).reduce((a, i) => a + i.quantity, 0);
      const freeLines = items.filter(isCoopSubFree);
      const free = freeLines.reduce((a, i) => a + i.quantity, 0);
      const allowed = (COOP.freeFor && COOP.freeFor[String(paid)]) || 0;
      if (free <= allowed) return;
      const updates = {};
      let excess = free - allowed;
      freeLines.slice().reverse().forEach((l) => { if (excess <= 0) return; const cut = Math.min(excess, l.quantity); updates[l.key] = l.quantity - cut; excess -= cut; });
      this._syncingC = true;
      try {
        await this.api('cart/update.js', { updates });
        this.cart = await this.fetchCart();
      } catch (err) {
        console.warn('[gt-cart] coop free sync', err);
      } finally {
        this._syncingC = false;
      }
    }

    async syncGifts() {
      if (!cfg.giftsEnabled || !cfg.rewardsEnabled || this._syncing) return;
      const tiers = this.activeTiers().filter((t) => t.variantId);
      const base = this.baseTotal();
      const giftLines = this.cart.items.filter(isGift);
      const earned = tiers.filter((t) => this.cart.items.some(isProduct) && base >= t.amount * 100);
      const remove = giftLines.filter((i) => !earned.some((t) => t.key === i.properties._gt_gift) || i.quantity > 1);
      const add = earned.filter((t) => !giftLines.some((i) => i.properties._gt_gift === t.key && i.quantity === 1));
      if (!remove.length && !add.length) return;
      this._syncing = true;
      try {
        if (remove.length) await this.api('cart/update.js', { updates: Object.fromEntries(remove.map((i) => [i.key, 0])) });
        if (add.length) await this.api('cart/add.js', { items: add.map((t) => ({ id: t.variantId, quantity: 1, properties: { _gt_gift: t.key } })) });
        this.cart = await this.fetchCart();
      } catch (err) {
        console.warn('[gt-cart] gift sync', err);
      } finally {
        this._syncing = false;
      }
    }

    /* ---------- events ---------- */
    onClick(e) {
      const t = e.target.closest('[data-gt-close],[data-gt-qty],[data-gt-remove-coopr],[data-gt-remove-coop],[data-gt-remove-ppb],[data-gt-remove-b2],[data-gt-remove],[data-gt-upgrade],[data-gt-upsell],[data-gt-feat-add],[data-gt-protect],[data-gt-checkout]');
      if (!t) return;
      if (t.hasAttribute('data-gt-close')) { e.preventDefault(); this.close(); return; }
      const line = Number(t.dataset.line);
      if (t.hasAttribute('data-gt-qty')) return this.changeLine(line, { quantity: Math.max(0, Number(t.dataset.gtQty)) });
      if (t.hasAttribute('data-gt-remove-coop')) {
        // The bags of one Coop deal only make sense together (the free bags need the paid ones), so remove the whole deal.
        const kind = t.dataset.gtRemoveCoop;
        const updates = {};
        const coopPacks = new Set(((cfg.bonus && cfg.bonus.items) || []).filter((x) => x.triggers && COOP && x.triggers.includes(COOP.sub)).map((x) => x.productId));
        this.cart.items.forEach((i) => { if (kind === 'sub' ? (isCoopSub(i) || isCoopSubFree(i) || coopPacks.has(i.product_id)) : (isCoopPaid(i) || isCoopFree(i))) updates[i.key] = 0; });
        return this.mutate(() => this.api('cart/update.js', { updates }));
      }
      if (t.hasAttribute('data-gt-remove-coopr')) {
        // the Coop auto-refill deal leaves as a whole (all scent lines); the e-book packs follow the any-subscription rule in syncGifts
        const updates = {};
        this.cart.items.forEach((i) => { if (isCoopRefill(i)) updates[i.key] = 0; });
        return this.mutate(() => this.api('cart/update.js', { updates }));
      }
      if (t.hasAttribute('data-gt-remove-ppb')) {
        // The Peck Purity bulk box leaves with the e-book pack it brought, unless another product in the cart still earns that pack.
        const packs = ((cfg.bonus && cfg.bonus.items) || []).filter((x) => x.triggers && BULKS.some((b) => x.triggers.includes(b.sub)));
        const updates = {};
        this.cart.items.forEach((i) => {
          if (isPPBulk(i)) updates[i.key] = 0;
          const p = packs.find((x) => x.productId === i.product_id);
          if (p && !this.cart.items.some((o) => !isPPBulk(o) && p.triggers.includes(o.product_id))) updates[i.key] = 0;
        });
        return this.mutate(() => this.api('cart/update.js', { updates }));
      }
      if (t.hasAttribute('data-gt-remove-b2')) {
        const boxIds = this.cart.items.filter(isB2Box).map((i) => i.product_id);
        const packs = ((cfg.bonus && cfg.bonus.items) || []).filter((x) => x.triggers && x.triggers.some((id) => boxIds.includes(id)));
        const updates = {};
        this.cart.items.forEach((i) => {
          if (isB2Box(i)) updates[i.key] = 0;
          const p = packs.find((x) => x.productId === i.product_id);
          if (p && !this.cart.items.some((o) => !isB2Box(o) && p.triggers.includes(o.product_id))) updates[i.key] = 0;
        });
        return this.mutate(() => this.api('cart/update.js', { updates }));
      }
      if (t.hasAttribute('data-gt-remove')) return this.changeLine(line, { quantity: 0 });
      if (t.hasAttribute('data-gt-upgrade')) {
        return this.changeLine(line, { quantity: Number(t.dataset.qty), selling_plan: Number(t.dataset.gtUpgrade) });
      }
      if (t.hasAttribute('data-gt-feat-add')) {
        const item = { id: Number(t.dataset.gtFeatAdd), quantity: 1 };
        if (t.dataset.plan) item.selling_plan = Number(t.dataset.plan);
        t.disabled = true;
        t.textContent = 'Adding…';
        return this.mutate(() => this.api('cart/add.js', { items: [item] }).then(() => this.fetchCart()));
      }
      if (t.hasAttribute('data-gt-upsell')) {
        const card = t.closest('[data-gt-card]');
        const sel = card && card.querySelector('select');
        const id = Number(sel ? sel.value : t.dataset.gtUpsell);
        t.disabled = true;
        t.textContent = 'Adding…';
        return this.mutate(() => this.api('cart/add.js', { items: [{ id, quantity: 1 }] }).then(() => this.fetchCart()));
      }
      if (t.hasAttribute('data-gt-checkout')) {
        t.classList.add('is-loading');
        document.dispatchEvent(new CustomEvent('gt-cart:checkout', { detail: this.cart }));
      }
    }
    onChange(e) {
      const fsel = e.target.closest('[data-gt-featvar]');
      if (fsel) { (this._featVar ||= {})[fsel.dataset.gtFeatvar] = Number(fsel.value); this.render(); return; }
      const vsel = e.target.closest('[data-gt-variant]');
      if (vsel) return this.swapVariant(vsel);
      const usel = e.target.closest('[data-gt-card] select');
      if (usel) {
        const o = usel.selectedOptions[0];
        const card = usel.closest('[data-gt-card]');
        card.querySelector('[data-gt-uprice]').innerHTML = (Number(o.dataset.cmp) > Number(o.dataset.price) ? '<s>' + money(o.dataset.cmp) + '</s> ' : '') + money(o.dataset.price);
        return;
      }
      const sel = e.target.closest('[data-gt-freq]');
      if (!sel) return;
      this.changeLine(Number(sel.dataset.line), { quantity: Number(sel.dataset.qty), selling_plan: Number(sel.value) });
    }
    // Shopify can't change a line's variant in place: add the new variant (same plan), then drop the old line.
    swapVariant(sel) {
      const newId = Number(sel.value);
      const qty = Number(sel.dataset.qty);
      const planId = Number(sel.dataset.plan) || null;
      return this.mutate(async () => {
        const item = { id: newId, quantity: qty };
        if (planId) {
          const prod = Object.values(this.products).find((p) => p && p.variants.some((v) => v.id === newId));
          const v = prod && prod.variants.find((x) => x.id === newId);
          const allocs = (v && v.selling_plan_allocations) || [];
          if (allocs.some((a) => a.selling_plan_id === planId)) item.selling_plan = planId;
          else if (allocs.length) {
            const plans = prod.selling_plan_groups.flatMap((g) => g.selling_plans);
            const oldName = (plans.find((p) => p.id === planId) || {}).name;
            const same = allocs.find((a) => (plans.find((p) => p.id === a.selling_plan_id) || {}).name === oldName);
            item.selling_plan = (same || allocs[0]).selling_plan_id;
          }
        }
        await this.api('cart/add.js', { items: [item] });
        return this.api('cart/update.js', { updates: { [sel.dataset.key]: 0 } });
      });
    }

    toast(msg) {
      const el = this.$('[data-gt-toast]');
      el.textContent = msg;
      el.hidden = false;
      clearTimeout(this._toastT);
      this._toastT = setTimeout(() => { el.hidden = true; }, 4000);
    }

    /* ---------- render ---------- */
    render() {
      const c = this.cart;
      const count = c.items.filter(isProduct).reduce((a, i) => a + i.quantity, 0);
      this.$('[data-gt-count]').textContent = count ? '(' + count + ')' : '';
      this.updateBubbles(count);
      this.classList.toggle('is-empty', false); // the LP falls back to /cart when this class is present; never use it
      this.toggleAttribute('data-empty', !count);

      if (!count) {
        this.$('[data-gt-rewards]').innerHTML = this.renderPerks(false);
        this.$('[data-gt-items]').innerHTML =
          '<div class="gt-empty"><p class="gt-empty-h">' + esc(cfg.emptyHeading) + '</p>' +
          (cfg.emptyText ? '<p class="gt-empty-p">' + esc(cfg.emptyText) + '</p>' : '') +
          '<a class="gt-btn" href="' + esc(cfg.emptyUrl) + '">' + esc(cfg.emptyButton) + '</a></div>';
        this.$('[data-gt-upsells]').innerHTML = this.renderUpsells();
        this.$('[data-gt-foot]').innerHTML = '';
        return;
      }
      this.$('[data-gt-rewards]').innerHTML = this.renderShipBar() + this.renderPerks(true) + this.renderRewards();
      const offer = this.offerMode();
      const rows = [];
      c.items.forEach((it, i) => {
        if (isAddon(it)) return;
        if (isPPBulk(it) && ppbTier(it)) { rows.push(this.renderPPBulk(it, i + 1)); return; }
        if (isCoopRefill(it) && coopRTier(it)) { if (!rows.coopR) { rows.coopR = true; rows.push(this.renderCoopRefill()); } return; }
        rows.push(this.renderItem(it, i + 1));
        // The free bag sits right under the bags it belongs to.
        if (offer && isB2Box(it)) rows.push(this.renderFreeBag(it));
      });
      this.$('[data-gt-items]').innerHTML = rows.join('') + (offer ? this.renderOfferGifts() : this.renderBonuses());
      const feature = this.renderFeature();
      this.$('[data-gt-upsells]').innerHTML = feature + this.renderUpsells(feature ? this.offer.productId : null) + this.renderTrust();
      this.$('[data-gt-foot]').innerHTML = this.renderFooter();
    }

    updateBubbles(count) {
      document.querySelectorAll('#cart-icon-bubble').forEach((b) => {
        let bubble = b.querySelector('.cart-count-bubble');
        if (!count) { if (bubble) bubble.remove(); return; }
        if (!bubble) { bubble = document.createElement('div'); bubble.className = 'cart-count-bubble'; b.appendChild(bubble); }
        bubble.innerHTML = '<span aria-hidden="true">' + count + '</span><span class="visually-hidden">' + count + ' items</span>';
      });
      const lp = document.getElementById('pmCartN');
      if (lp) { if (count) { lp.textContent = count; lp.removeAttribute('hidden'); } else lp.setAttribute('hidden', ''); }
    }

    renderPerks(hasItems) {
      const bits = [];
      if (cfg.deliveryEnabled && cfg.deliveryText && hasItems) {
        const now = new Date();
        const start = now.getHours() >= cfg.cutoffHour ? 1 : 0;
        const a = addBusinessDays(now, cfg.deliveryMin + start);
        const b = addBusinessDays(now, Math.max(cfg.deliveryMax, cfg.deliveryMin) + start);
        bits.push('<div class="gt-perk">' + ICON.truck + '<span>' + esc(fill(cfg.deliveryText, { start: fmtDate(a), end: fmtDate(b) })) + '</span></div>');
      }
      if (cfg.perkText && !cfg.fsEnabled) bits.push('<div class="gt-perk gt-perk--ok"><span class="gt-tick">' + ICON.check + '</span><span>' + esc(cfg.perkText) + '</span></div>');
      return bits.length ? '<div class="gt-perks">' + bits.join('') + '</div>' : '';
    }

    shipUnlocked() {
      return cfg.fsEnabled && cfg.fsThreshold > 0 && this.baseTotal() >= cfg.fsThreshold * 100;
    }
    renderShipBar() {
      if (!cfg.fsEnabled || !(cfg.fsThreshold > 0) || this.coopSubMode() || this.ppBulkMode() || this.b2g1Mode()) return '';
      // Oct 19: no free first-order shipping any more, so subscription carts get the normal free-shipping progress bar
      const goal = cfg.fsThreshold * 100;
      const base = this.baseTotal();
      const pct = Math.min(100, (base / goal) * 100);
      const done = base >= goal;
      const msg = done ? esc(cfg.fsDone) : esc(cfg.fsProgress).replace('{amount}', '<b class="gt-ship-amt">' + money(goal - base) + '</b>');
      return '<div class="gt-ship' + (done ? ' is-done' : '') + '"><p class="gt-ship-msg">' + ICON.truck + '<span>' + msg + '</span></p>' +
        '<div class="gt-ship-track" role="progressbar" aria-label="Progress to free shipping" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><div class="gt-ship-fill" style="width:' + pct + '%"></div></div></div>';
    }

    renderRewards() {
      if (!cfg.rewardsEnabled) return '';
      const tiers = this.activeTiers();
      if (!tiers.length) return '';
      const base = this.baseTotal();
      const max = tiers[tiers.length - 1].amount * 100;
      const next = tiers.find((t) => base < t.amount * 100);
      const pct = Math.min(100, (base / max) * 100);
      const msg = next
        ? fill(cfg.rewardProgress, { amount: '<b>' + money(next.amount * 100 - base) + '</b>', reward: '<b>' + esc(next.label) + '</b>' })
        : esc(cfg.rewardDone);
      const marks = tiers.map((t) => {
        const on = base >= t.amount * 100;
        const left = (t.amount * 100 / max) * 100;
        return '<div class="gt-mark' + (on ? ' is-on' : '') + '" style="left:' + left + '%"><span class="gt-mark-dot">' + (on ? ICON.check : ICON.gift) + '</span><span class="gt-mark-lbl">' + money(t.amount * 100).replace(/\.00$/, '') + '</span></div>';
      }).join('');
      return '<div class="gt-rewards"><p class="gt-rewards-msg">' + msg + '</p>' +
        '<div class="gt-track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '"><div class="gt-fill" style="width:' + pct + '%"></div>' + marks + '</div></div>';
    }

    renderItem(it, line) {
      const gift = isGift(it);
      const sp = it.selling_plan_allocation;
      // Review "Mystery Gift" (from /pages/mystery-gift): free Coop Refresher via the shopper's GIFT- code once $15+ of other products is in the order.
      const mg = !!(it.properties && it.properties._mystery_gift);
      const mgOther = mg ? this.cart.items.filter((i) => i.product_id !== it.product_id && isProduct(i)).reduce((t, i) => t + i.final_line_price, 0) : 0;
      const mgFree = mg && it.final_line_price === 0;
      const prod = this.products[it.handle];
      const variant = prod && prod.variants.find((v) => v.id === it.variant_id);
      const coopFreeNow = (isCoopFree(it) || isCoopSubFree(it)) && it.final_line_price === 0;
      const title = coopFreeNow ? 'FREE Coop Refresher Bag' : isCoop(it) ? 'GrubTerra Coop Refresher' : B2O && isB2Box(it) ? b2Name(it) + ' 3-Month Supply' : isB2Monthly(it) ? 'Peck Purity Monthly Plan' : it.product_title;
      const variantTitle = it.product_has_only_default_variant ? '' : vName(it.variant_title);
      // Hen Harmony: flock size x bags sets the refill plan (dose), which a variant swap here can't keep right, so no switcher (hh-rows/HANDOFF.md).
      const switchable = !gift && !mg && !isCoop(it) && !isB2Box(it) && !isB2Monthly(it) && it.product_id !== 7614584258673 && cfg.variantSwitch && prod && prod.variants.filter((v) => v.available || v.id === it.variant_id).length > 1;
      let variantHtml = variantTitle ? '<p class="gt-var">' + esc(variantTitle) + '</p>' : '';
      if (switchable) {
        const optName = (prod.options && prod.options[0] && (prod.options[0].name || prod.options[0])) || 'Option';
        variantHtml = '<label class="gt-vsel"><span>' + esc(optName) + '</span><select data-gt-variant data-key="' + esc(it.key) + '" data-qty="' + it.quantity + '" data-plan="' + (sp ? sp.selling_plan.id : '') + '">' +
          prod.variants.filter((v) => v.available || v.id === it.variant_id).map((v) => '<option value="' + v.id + '"' + (v.id === it.variant_id ? ' selected' : '') + '>' + esc(vName(v.title)) + '</option>').join('') +
          '</select></label>';
      }
      if (isB2Box(it)) {
        const per = b2Pouches(it), total = per * it.quantity;
        variantHtml = '<p class="gt-var gt-var--deal">🎁 Buy ' + (total - per) + ' Get ' + per + ' FREE · ' + total + b2Unit(it, total) + '</p>';
      }
      let compareLine = unitValue(variant, sp, it.original_price) * it.quantity;
      let shown = it.final_line_price;
      // Gift-stack offer lines are measured the way the page measures them: $32.99 a pouch. The 3-Month line shows its paid bags;
      // the 3rd bag gets its own row (renderFreeBag).
      if (B2O && (isB2Box(it) || isB2Monthly(it))) {
        const paid = isB2Box(it) ? it.quantity - 1 : it.quantity;
        shown = isB2Box(it) ? it.final_line_price - bagCharge(it) : it.final_line_price;
        compareLine = (isB2Box(it) ? b2Base(it) : B2O.base) * b2Pouches(it) * paid;
        variantHtml = '<p class="gt-var">' + esc(String(it.variant_title || '').replace(/(\d+)-(\d+)/, '$1–$2')) + '</p>';
      }
      if (isCoop(it)) {
        const deal = it.properties && it.properties.Deal ? String(it.properties.Deal) : '';
        variantHtml = '<p class="gt-var">' + esc(it.variant_title || '') + ' scent</p>' +
          ((isCoopFree(it) || isCoopSubFree(it)) && !coopFreeNow ? '<p class="gt-var">Not covered by your deal: one Coop deal per order</p>' : '') +
          (isCoopSubFree(it) && coopFreeNow ? '<p class="gt-var gt-var--deal">Free on every box while you stay subscribed</p>' : '') +
          (deal && !isCoopFree(it) && !isCoopSubFree(it) ? '<p class="gt-var gt-var--deal">🎁 ' + esc(deal.replace(/ \((savings for the life of your subscription|locked-in price|locked in for life)\)/, '')) + (isCoopSub(it) ? ' · savings for the life of your subscription' : '') + '</p>' : '');
      }
      const priceHtml = isCoop(it) && it.final_line_price === 0
        ? '<s>' + money(compareLine) + '</s><strong class="gt-free">FREE</strong>'
        : mg
        ? (it.final_line_price === 0 ? '<s>' + money(it.original_line_price) + '</s><strong class="gt-free">FREE</strong>' : '<strong>' + money(it.final_line_price) + '</strong>')
        : gift
        ? (it.final_line_price === 0 ? '<s>' + money(it.original_line_price) + '</s><strong class="gt-free">FREE</strong>' : '<strong>' + money(it.final_line_price) + '</strong>')
        : (compareLine > shown ? '<s>' + money(compareLine) + '</s>' : '') + '<strong>' + money(shown) + '</strong>' +
          (cfg.showLineSave && compareLine > shown ? '<em class="gt-linesave">(Save ' + money(compareLine - shown) + ')</em>' : '');

      let sub = '';
      if (!gift && sp) {
        // Plan editing is off by default (churn); subscribers just see a savings tag.
        let freq = cfg.subTag ? '<span class="gt-subtag">' + ICON.tag + esc(cfg.subTag) + '</span>' : '';
        if (cfg.freqEnabled && prod && variant) {
          const allocIds = new Set((variant.selling_plan_allocations || []).map((a) => a.selling_plan_id));
          const group = (prod.selling_plan_groups || []).find((g) => g.selling_plans.some((p) => p.id === sp.selling_plan.id));
          const plans = group ? group.selling_plans.filter((p) => allocIds.has(p.id)) : [];
          if (plans.length > 1) {
            freq = '<label class="gt-freq">' + ICON.repeat + '<span class="visually-hidden">Delivery frequency</span><select data-gt-freq data-line="' + line + '" data-qty="' + it.quantity + '">' +
              plans.map((p) => '<option value="' + p.id + '"' + (p.id === sp.selling_plan.id ? ' selected' : '') + '>' + esc(p.name) + '</option>').join('') + '</select></label>';
          }
        }
        sub = '<div class="gt-subrow">' + freq + (cfg.subNote ? '<span class="gt-subnote">' + esc(cfg.subNote) + '</span>' : '') + '</div>';
      }
      let upbox = '';
      // Never pitch Subscribe & Save on a free item.
      if (!gift && !mg && !sp && !isCoop(it) && it.final_line_price > 0 && cfg.upgradeEnabled && variant && prod) {
        const pick = pickPlan(prod, variant);
        const unitSave = pick ? it.original_price - pick.price : 0;
        if (unitSave > 0) {
          const pct = Math.round((unitSave / it.original_price) * 100);
          const map = { pct: pct, amount: money(unitSave * it.quantity), plan: pick.name };
          const icons = [ICON.tag, ICON.cal, ICON.shield];
          const bullets = (cfg.upBullets || []).map((b, k) => (b ? '<li>' + (icons[k] || ICON.check) + '<span>' + esc(fill(b, map)) + '</span></li>' : '')).join('');
          // The money saved is highlighted in the heading.
          const head = fill(esc(cfg.upHeading).replace(/\{amount\}/g, '<span class="gt-upbox-amt">' + map.amount + '</span>'), map);
          upbox = '<div class="gt-upbox' + (cfg.upBadge ? ' has-badge' : '') + '">' + (cfg.upBadge ? '<span class="gt-upbox-badge">' + esc(cfg.upBadge) + '</span>' : '') +
            '<p class="gt-upbox-h">' + head + '</p>' + (bullets ? '<ul>' + bullets + '</ul>' : '') +
            '<button type="button" class="gt-btn gt-btn--3d" data-gt-upgrade="' + pick.id + '" data-line="' + line + '" data-qty="' + it.quantity + '">' + esc(fill(cfg.upButton, map)) + '</button></div>';
        }
      }

      const discounts = (it.line_level_discount_allocations || [])
        .filter((d) => !gift && !mg && !isCoop(it) && !(B2O && isB2Box(it)) && d.amount > 0)
        .map((d) => '<li>' + esc(d.discount_application.title) + ' (−' + money(d.amount) + ')</li>').join('');

      const qty = gift
        ? '<span class="gt-giftbadge">' + ICON.gift + 'Reward</span>'
        : isB2Box(it)
        ? '<span class="gt-qtyfix">' + (isHHB2(it) ? (b2Pouches(it) * (it.quantity - 1)) + ' bags' : (B2O ? (it.quantity - 1) + ' months · ' + (b2Pouches(it) * (it.quantity - 1)) : b2Pouches(it) * it.quantity) + ' pouches') + '</span>' +
          '<button type="button" class="gt-rm" data-gt-remove-b2 aria-label="Remove this ' + b2Name(it) + ' deal">' + ICON.trash + '</button>'
        : isCoop(it)
        ? '<span class="gt-qtyfix">' + it.quantity + (it.quantity > 1 ? ' bags' : ' bag') + (coopFreeNow ? ' FREE' : '') + '</span>' +
          (coopFreeNow ? '' : '<button type="button" class="gt-rm" data-gt-remove-coop="' + (isCoopSub(it) || isCoopSubFree(it) ? 'sub' : 'ot') + '" aria-label="Remove this Coop Refresher deal">' + ICON.trash + '</button>')
        : '<div class="gt-qty"><button type="button" data-gt-qty="' + (it.quantity - 1) + '" data-line="' + line + '" aria-label="Decrease quantity">' + ICON.minus + '</button>' +
          '<span aria-live="polite">' + it.quantity + '</span>' +
          '<button type="button" data-gt-qty="' + (it.quantity + 1) + '" data-line="' + line + '" aria-label="Increase quantity">' + ICON.plus + '</button></div>' +
          '<button type="button" class="gt-rm" data-gt-remove data-line="' + line + '" aria-label="Remove ' + esc(title) + '">' + ICON.trash + '</button>';

      if (mg) variantHtml += '<p class="gt-var gt-var--deal">' + (mgFree ? '🎁 Unlocked! Your gift is FREE' : '🎁 Add ' + money(Math.max(0, 1500 - mgOther)) + ' more of other products to make it FREE') + '</p>';
      const group = gift ? 'Free Reward'
        : mg ? '🎁 Your Mystery Gift'
        : B2O && isB2Box(it) ? 'Delivered every 3 months'
        : isCoopSub(it) && sp ? planLabel(sp.selling_plan.name) + ' · FREE shipping'
        : coopFreeNow && isCoopSubFree(it) ? '🎁 FREE on every box'
        : coopFreeNow ? '🎁 Free with your deal'
        : isCoopPaid(it) || isCoopFree(it) ? 'One-Time Deal'
        : sp ? planLabel(sp.selling_plan.name) : 'One-Time Purchase';
      return '<div class="gt-line"><p class="gt-group"><span>' + esc(group) + '</span></p><div class="gt-item' + (gift ? ' gt-item--gift' : '') + '">' +
        '<a class="gt-img" href="' + esc(it.url) + '" tabindex="-1">' + (it.image ? '<img src="' + esc(img(it.image, 180)) + '" alt="" width="84" height="84" loading="lazy">' : '') + '</a>' +
        '<div class="gt-info">' +
          '<div class="gt-top"><a class="gt-name" href="' + esc(it.url) + '">' + esc(title) + '</a><div class="gt-price">' + priceHtml + '</div></div>' +
          variantHtml +
          (discounts ? '<ul class="gt-disc">' + discounts + '</ul>' : '') +
          sub +
          '<div class="gt-actions">' + qty + '</div>' +
        '</div></div>' + upbox + '</div>';
    }

    // Cross-sell: the first offer (in priority order) whose product family isn't in the cart yet.
    pickOffer() {
      const f = cfg.feature;
      if (!f || !f.enabled || !this.cart) return null;
      const items = this.cart.items.filter(isProduct);
      if (!items.length) return null;
      return (f.offers || []).find((o) => o.productId && o.handle && !items.some((i) => i.product_id === o.productId || offerHas(o, i))) || null;
    }
    // Grüns-style companion offer card, added on the offer's subscription plan.
    renderFeature() {
      const f = cfg.feature;
      const o = this.offer;
      const prod = this.offerProduct;
      if (!o || !prod || !this.cart) return '';
      const only = words(o.variants);
      const avail = prod.variants.filter((v) => v.available &&
        (!only.length || only.some((w) => String(v.title).toLowerCase().includes(w))) &&
        (!f.subscribe || offerPlan(prod, v)));
      if (!avail.length) return '';
      const chosen = (this._featVar || {})[prod.id];
      const v = avail.find((x) => x.id === chosen) || avail[0];
      const plan = f.subscribe ? offerPlan(prod, v) : null;
      const price = plan ? plan.price : v.price;
      const was = v.price;
      const pct = was > price ? Math.round(((was - price) / was) * 100) : 0;
      const map = { pct: pct, plan: plan ? cadence(plan.name) : '', price: money(price) };
      const sel = avail.length > 1
        ? '<select data-gt-featvar="' + prod.id + '" aria-label="Choose option">' + avail.map((x) => '<option value="' + x.id + '"' + (x.id === v.id ? ' selected' : '') + '>' + esc(vName(x.title)) + '</option>').join('') + '</select>'
        : '';
      return '<section class="gt-feat">' +
        (o.heading ? '<h3 class="gt-feat-h">' + esc(fill(o.heading, map)) + '</h3>' : '') +
        (o.text ? '<p class="gt-feat-p">' + esc(fill(o.text, map)) + '</p>' : '') +
        '<div class="gt-feat-card">' +
          '<a class="gt-feat-img" href="' + esc(prod.url) + '">' + (prod.featured_image ? '<img src="' + esc(img(prod.featured_image, 240)) + '" alt="" loading="lazy" width="96" height="96">' : '') + '</a>' +
          '<div class="gt-feat-body">' +
            '<p class="gt-feat-t">' + esc(o.title || shortTitle(prod.title)) + ' - ' + money(price) + (was > price ? ' <s>' + money(was) + '</s>' : '') + '</p>' +
            (f.sub && plan ? '<p class="gt-feat-sub">' + esc(fill(f.sub, map)) + '</p>' : '') +
            sel +
            '<button type="button" class="gt-btn gt-btn--gold" data-gt-feat-add="' + v.id + '" data-plan="' + (plan ? plan.id : '') + '">' + esc(f.button || 'Add to Cart') + '</button>' +
          '</div></div></section>';
    }

    renderUpsells(excludeId) {
      const inCart = new Set((this.cart ? this.cart.items : []).map((i) => i.product_id));
      if (excludeId) inCart.add(excludeId);
      const list = (cfg.upsells || [])
        .filter((p) => !inCart.has(p.productId) && p.variants.some((v) => v.available))
        .slice(0, cfg.upsellLimit || 6);
      if (!list.length) return '';
      const cards = list.map((p) => {
        const avail = p.variants.filter((v) => v.available);
        const v0 = avail[0];
        const select = avail.length > 1
          ? '<select aria-label="Choose option">' + avail.map((v) => '<option value="' + v.id + '" data-price="' + v.price + '" data-cmp="' + (v.compareAt || 0) + '">' + esc(vName(v.title)) + '</option>').join('') + '</select>'
          : '';
        return '<div class="gt-card" data-gt-card>' +
          '<a class="gt-card-img" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy" width="120" height="120">' : '') + '</a>' +
          '<div class="gt-card-body"><a class="gt-card-t" href="' + esc(p.url) + '">' + esc(shortTitle(p.title)) + '</a>' +
          '<p class="gt-card-p" data-gt-uprice>' + (v0.compareAt > v0.price ? '<s>' + money(v0.compareAt) + '</s> ' : '') + money(v0.price) + '</p>' +
          '<div class="gt-card-buy">' + select + '<button type="button" class="gt-add" data-gt-upsell="' + v0.id + '">Add</button></div></div></div>';
      }).join('');
      return '<section class="gt-ups gt-ups--' + esc(cfg.upsellLayout || 'list') + '"><h3 class="gt-ups-h">' + esc(cfg.upsellHeading) + '</h3><div class="gt-ups-row">' + cards + '</div></section>';
    }

    renderFooter() {
      const c = this.cart;
      let savings = c.total_discount || 0;
      c.items.forEach((it) => {
        if (isAddon(it)) {
          const m = cfg.bonus.items.find((x) => x.productId === it.product_id);
          const v = Math.max((m && m.value) || 0, it.original_price) * it.quantity;
          if (v > it.final_line_price) savings += v - it.final_line_price - ((it.original_line_price - it.final_line_price) || 0);
          return;
        }
        if (!isProduct(it)) return;
        const sp = it.selling_plan_allocation;
        const prod = this.products[it.handle];
        const variant = prod && prod.variants.find((v) => v.id === it.variant_id);
        const cmp = unitValue(variant, sp, it.original_price) * it.quantity;
        if (cmp > it.original_line_price) savings += cmp - it.original_line_price;
      });
      const cartDisc = (c.cart_level_discount_applications || [])
        .map((d) => '<div class="gt-row gt-row--save"><span>' + esc(d.title) + '</span><span>−' + money(d.total_allocated_amount) + '</span></div>').join('');
      const was = c.total_price + savings;
      const pct = savings > 0 ? Math.round((savings / was) * 100) : 0;
      const ticons = [ICON.star, ICON.cal, ICON.money];
      const trust = (cfg.footTrust || []).filter(Boolean);
      return (cfg.timerEnabled && cfg.timerText ? '<div class="gt-timer">' + ICON.clock + '<span>' + esc(cfg.timerText).replace('{time}', '<b data-gt-time>' + (this._timerText || '') + '</b>') + '</span></div>' : '') +
        (cartDisc ? '<div class="gt-rows">' + cartDisc + '</div>' : '') +
        '<div class="gt-sub"><span class="gt-sub-l">Subtotal</span><span class="gt-sub-r">' +
          (cfg.offPill && pct > 0 ? '<span class="gt-pill">' + pct + '% Off</span>' : '') +
          (savings > 0 ? '<s>' + money(was) + '</s>' : '') + '<b>' + money(c.total_price) + '</b></span></div>' +
        '<form action="' + root + 'cart" method="post" class="gt-checkout-form"><button type="submit" name="checkout" class="gt-btn gt-btn--3d gt-btn--checkout" data-gt-checkout><span>' + esc(cfg.checkoutText) + '</span>' + ICON.lock + '</button></form>' +
        (trust.length ? '<div class="gt-ftrust">' + trust.map((x, k) => '<div>' + (ticons[k] || ICON.check) + '<span>' + esc(x) + '</span></div>').join('') + '</div>' : '');
    }

    // Bonus lines, shown small under the products: covers, name, ~~value~~ FREE.
    // Peck Purity bulk box: the paid bags (deal price, then the refill terms) and, right under them, the free bags as their own FREE row.
    renderPPBulk(it, line) {
      const B = bulkOf(it), t = ppbTier(it), sp = it.selling_plan_allocation;
      const paidWas = B.unit * t.pay, freeWas = B.unit * t.free, now = it.final_line_price;
      const prod = this.products[it.handle];
      const variant = prod && prod.variants.find((v) => v.id === it.variant_id);
      const alloc = variant && (variant.selling_plan_allocations || []).find((a) => a.selling_plan_id === sp.selling_plan.id);
      const adj = alloc && (alloc.price_adjustments || []).find((a) => a.position === 2);
      const refillUnit = adj ? adj.price : Math.round(B.unit * 0.9);
      const bag = (n) => '<span class="gt-img gt-img--bag"><img src="' + esc(img(B.pouchImg, 180)) + '" alt="' + esc(B.name) + ' bag" width="84" height="84" loading="lazy">' + (n > 1 ? '<i class="gt-gift-x">×' + n + '</i>' : '') + '</span>';
      const deal = 'Buy ' + t.pay + ' Get ' + t.free + ' FREE';
      return '<div class="gt-line"><p class="gt-group"><span>Your bulk deal · FREE shipping</span></p><div class="gt-item">' +
          bag(t.pay) +
          '<div class="gt-info"><div class="gt-top"><span class="gt-name">' + esc(B.name) + ' Bulk Deal</span><div class="gt-price">' +
            (paidWas > now ? '<s>' + money(paidWas) + '</s>' : '') + '<strong>' + money(now) + '</strong></div></div>' +
          '<p class="gt-var gt-var--deal">🎁 ' + esc(deal) + ' · ' + t.total + ' bags in your first box</p>' +
          '<p class="gt-var">Auto-refill: ' + t.total + ' bags every ' + t.months + ' months at 10% off (' + money(refillUnit * t.total) + '). Cancel anytime.</p>' +
          '<div class="gt-actions"><span class="gt-qtyfix">' + t.pay + ' bags</span>' +
            '<button type="button" class="gt-rm" data-gt-remove-ppb aria-label="Remove this ' + esc(B.name) + ' deal">' + ICON.trash + '</button></div>' +
        '</div></div></div>' +
        '<div class="gt-line gt-line--freebag"><p class="gt-group"><span>🎁 Free in your first box</span></p><div class="gt-item gt-item--freebag">' +
          bag(t.free) +
          '<div class="gt-info"><div class="gt-top"><span class="gt-name">FREE ' + esc(B.name) + ' Bag' + (t.free > 1 ? 's' : '') + '</span><div class="gt-price"><s>' + money(freeWas) + '</s><strong class="gt-free">FREE</strong></div></div>' +
          '<p class="gt-var">' + t.free + ' bags · free in your first box</p>' +
          '<span class="gt-qtyfix">Included with your ' + esc(deal) + ' deal</span></div></div></div>';
    }
    // Coop auto-refill box: all scent lines as one deal, then the free bags as their own FREE row (same look as renderPPBulk).
    renderCoopRefill() {
      const lines = this.cart.items.filter(isCoopRefill), t = coopRTier(lines[0]), sp = lines[0].selling_plan_allocation;
      const now = lines.reduce((a, l) => a + l.final_line_price, 0), paidWas = COOPR.unit * t.pay, freeWas = COOPR.unit * t.free;
      const prod = this.products[lines[0].handle];
      const variant = prod && prod.variants.find((v) => v.id === lines[0].variant_id);
      const alloc = variant && (variant.selling_plan_allocations || []).find((a) => a.selling_plan_id === sp.selling_plan.id);
      const adj = alloc && (alloc.price_adjustments || []).find((a) => a.position === 2);
      const refillUnit = adj ? adj.price : Math.round(COOPR.unit * 0.9);
      const scents = lines.map((l) => l.quantity + ' ' + (l.variant_title || '')).join(', ');
      const bag = (n) => '<span class="gt-img gt-img--bag"><img src="' + esc(img(COOPR.img, 180)) + '" alt="Coop Refresher bag" width="84" height="84" loading="lazy">' + (n > 1 ? '<i class="gt-gift-x">×' + n + '</i>' : '') + '</span>';
      const deal = 'Buy ' + t.pay + ' Get ' + t.free + ' FREE';
      return '<div class="gt-line"><p class="gt-group"><span>Your Coop Refresher deal · FREE shipping</span></p><div class="gt-item">' +
          bag(t.pay) +
          '<div class="gt-info"><div class="gt-top"><span class="gt-name">Coop Refresher Deal</span><div class="gt-price">' +
            (paidWas > now ? '<s>' + money(paidWas) + '</s>' : '') + '<strong>' + money(now) + '</strong></div></div>' +
          '<p class="gt-var gt-var--deal">🎁 ' + esc(deal) + ' · ' + t.total + ' bags in your first box</p>' +
          '<p class="gt-var">' + esc(scents) + '</p>' +
          '<p class="gt-var">Auto-refill: ' + t.total + ' bags every ' + t.months + ' months at 10% off (' + money(refillUnit * t.total) + '). Cancel anytime.</p>' +
          '<div class="gt-actions"><span class="gt-qtyfix">' + t.pay + ' bags</span>' +
            '<button type="button" class="gt-rm" data-gt-remove-coopr aria-label="Remove this Coop Refresher deal">' + ICON.trash + '</button></div>' +
        '</div></div></div>' +
        '<div class="gt-line gt-line--freebag"><p class="gt-group"><span>🎁 Free in your first box</span></p><div class="gt-item gt-item--freebag">' +
          bag(t.free) +
          '<div class="gt-info"><div class="gt-top"><span class="gt-name">FREE Coop Refresher Bag' + (t.free > 1 ? 's' : '') + '</span><div class="gt-price"><s>' + money(freeWas) + '</s><strong class="gt-free">FREE</strong></div></div>' +
          '<p class="gt-var">' + t.free + (t.free > 1 ? ' bags' : ' bag') + ' · free in your first box</p>' +
          '<span class="gt-qtyfix">Included with your ' + esc(deal) + ' deal</span></div></div></div>';
    }
    // The free 3rd bag as its own line: the bag, its pouch count, ~~$32.99 a pouch~~ FREE. Shows its real price if the cart charges for it.
    renderFreeBag(it) {
      const n = b2Pouches(it), was = b2Base(it) * n, now = bagCharge(it);
      return '<div class="gt-line gt-line--freebag"><p class="gt-group"><span>🎁 Free on your first order</span></p><div class="gt-item gt-item--freebag">' +
        '<span class="gt-img gt-img--bag"><img src="' + esc(img(b2Img(it), 180)) + '" alt="' + b2Name(it) + ' bag" width="84" height="84" loading="lazy">' + (n > 1 ? '<i class="gt-gift-x">×' + n + '</i>' : '') + '</span>' +
        '<div class="gt-info"><div class="gt-top"><span class="gt-name">FREE ' + b2Name(it) + ' Bag' + (isHHB2(it) && n > 1 ? 's' : '') + '</span><div class="gt-price">' +
          (was > now ? '<s>' + money(was) + '</s>' : '') + (now === 0 ? '<strong class="gt-free">FREE</strong>' : '<strong>' + money(now) + '</strong>') + '</div></div>' +
        '<p class="gt-var">' + n + b2Unit(it, n) + ' · free on your 1st order only</p>' +
        '<span class="gt-qtyfix">Included with your 3-Month Supply</span></div></div></div>';
    }

    // Offer carts: each freebie is its own full row (shipping, e-books, protection) so the cart reads as a stack of gifts.
    // A row only says FREE when the cart really charges $0 for it; otherwise it shows the real price.
    renderOfferGifts(opts) {
      opts = opts || {};
      const items = this.cart.items, b = cfg.bonus || { items: [], covers: [] };
      const rows = [];
      let value = 0;
      const cover = (u) => '<img src="' + esc(img(u, 90)) + '" alt="" width="22" height="30" loading="lazy">';
      const add = (media, name, text, was, now) => {
        if (now === 0) value += was;
        rows.push('<div class="gt-gift"><span class="gt-gift-m">' + media + '</span><span class="gt-gift-t"><b>' + esc(name) + '</b>' + (text ? '<small>' + esc(text) + '</small>' : '') + '</span>' +
          '<span class="gt-gift-p">' + (was > now ? '<s>' + money(was) + '</s>' : '') + (now === 0 ? '<b class="gt-free">FREE</b>' : '<b>' + money(now) + '</b>') + '</span></div>');
      };
      // The free bag has its own line above (renderFreeBag), so it isn't repeated here.
      // Oct 19: the first order pays shipping, so there is no free-shipping gift row here any more
      items.filter(isAddon).forEach((i) => {
        const ms = b.items.filter((x) => x.productId === i.product_id), m = ms.find((x) => x.triggers && x.triggers.length) || ms[0];
        if (!m) return;
        const now = i.final_line_price;
        // The Vols 4-6 pack (Flock Resilience bundle) is its own gift row; it's known by its handle, whatever the bonus settings say.
        if (i.handle === 'hen-harmony-bonus-pack' || (m.triggers && m.triggers.length)) {
          add('<span class="gt-gift-covers">' + ((m.covers && m.covers.length) ? m.covers : HH_COVERS).slice(0, 3).map(cover).join('') + '</span>', '3 More Flock E-books', 'Hot Summers, Cold Coops & 2 more guides', m.value || 1500, now);
        } else {
          add('<span class="gt-gift-covers">' + (b.covers || []).slice(0, 3).map(cover).join('') + '</span>', '3 Flock Health E-books', 'Gut health, worms & laying guides', 1500, now);
          add(SVG_SHIELD, 'Shipping Protection', 'Lost, stolen or damaged package? Covered.', Math.max((m.value || 2200) - 1500, 0), now);
        }
      });
      const free = rows.filter((r) => r.includes('gt-free')).length;
      return '<div class="gt-gifts"><p class="gt-gifts-h">🎁 ' + free + ' FREE gifts in your order' + (value ? '<span>' + money(value) + ' value</span>' : '') + '</p>' + rows.join('') + '</div>';
    }

    renderBonuses() {
      const b = cfg.bonus;
      if (!b || !b.enabled) return '';
      const lines = this.cart.items.filter(isAddon);
      if (!lines.length) return '';
      const rows = lines.map((i) => {
        const m = b.items.find((x) => x.productId === i.product_id);
        const was = Math.max((m && m.value) || 0, i.original_price) * i.quantity;
        const now = i.final_line_price;
        const covers = i.image
          ? '<img src="' + esc(img(i.image, 90)) + '" alt="" width="30" height="40" loading="lazy">'
          : (b.covers || []).slice(0, 3).map((u) => '<img src="' + esc(img(u, 90)) + '" alt="" width="30" height="40" loading="lazy">').join('');
        const own = m && m.covers && m.covers.length ? m.covers.slice(0, 3).map((u) => '<img src="' + esc(img(u, 90)) + '" alt="" width="30" height="40" loading="lazy">').join('') : '';
        const ttl = (m && m.title) || b.title || i.product_title, txt = (m && m.text) || b.text;
        return '<div class="gt-bonus"><span class="gt-bonus-covers">' + (own || covers) + '</span><span class="gt-bonus-t"><b>' + esc(ttl) + '</b>' +
          (txt ? '<small>' + esc(txt) + '</small>' : '') + '</span><span class="gt-bonus-p">' + (was > now ? '<s>' + money(was) + '</s>' : '') +
          (now === 0 ? '<b class="gt-free">FREE</b>' : '<b>' + money(now) + '</b>') + '</span></div>';
      }).join('');
      return '<div class="gt-line gt-bonuses"><p class="gt-group"><span>' + esc(b.label) + '</span></p>' + rows + '</div>';
    }

    // Badges, payment icons and "continue shopping" sit at the end of the scroll area so the pinned footer stays short.
    renderTrust() {
      return '<div class="gt-trustwrap">' +
        (cfg.badgesEnabled ? '<div class="gt-badges">' + (cfg.badgesTitle ? '<p class="gt-badges-h">' + ICON.lock + esc(cfg.badgesTitle) + ICON.lock + '</p>' : '') +
          '<div class="gt-badges-row">' + (cfg.badges || []).filter(Boolean).map((b) => '<span class="gt-badge">' + ICON.shield + esc(b) + '</span>').join('') + '</div>' +
          (cfg.paymentIcons ? '<div class="gt-pays">' + cfg.paymentIcons + '</div>' : '') + '</div>' : '') +
        (!cfg.badgesEnabled && (cfg.trustText || cfg.paymentIcons) ? '<div class="gt-trust">' + (cfg.trustText ? '<span>' + esc(cfg.trustText) + '</span>' : '') + (cfg.paymentIcons ? '<div class="gt-pays">' + cfg.paymentIcons + '</div>' : '') + '</div>' : '') +
        (cfg.continueText ? '<button type="button" class="gt-continue" data-gt-close>' + esc(cfg.continueText) + '</button>' : '') +
        '</div>';
    }
  }

  customElements.define('cart-drawer', GTCart);
})();

